(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kay-cinematic-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const register = () => {
    if (customElements.get('kay-cinematic-home')) return;
    class KayCinematicHome extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.events || !this.isConnected) return;
        this.video = this.querySelector('[data-kay-video]');
        this.scrollScene = this.querySelector('[data-kay-scroll]');
        this.stage = this.querySelector('[data-kay-stage]');
        this.captions = Array.from(this.querySelectorAll('[data-kay-caption]'));
        if (!this.video || !this.scrollScene || !this.stage) return;
        this.events = new AbortController();
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.sceneVisible = true;
        this.header = document.querySelector('.header-wrapper');
        this.headerHeight = 0;
        this.frame = 0;
        this.captionIndex = -1;
        const options = { signal: this.events.signal };
        const schedule = () => {
          if (this.frame || !this.sceneVisible || document.hidden) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateScene(); });
        };
        this.schedule = schedule;
        window.addEventListener('scroll', schedule, { ...options, passive: true });
        window.addEventListener('resize', schedule, { ...options, passive: true });
        document.addEventListener('visibilitychange', schedule, options);
        this.video.addEventListener('loadedmetadata', schedule, options);
        this.video.addEventListener('loadeddata', () => {
          this.classList.add('kch--video-ready');
          schedule();
        }, options);
        this.video.addEventListener('seeked', schedule, options);
        this.video.addEventListener('error', () => {
          this.classList.add('kch--static');
          this.classList.remove('kch--video-ready');
          this.showCaption(0);
        }, options);
        const refreshSource = () => this.configureVideo();
        this.reducedMotion.addEventListener('change', refreshSource, options);
        this.mobile.addEventListener('change', refreshSource, options);
        this.observer = new IntersectionObserver(entries => {
          this.sceneVisible = entries[0].isIntersecting;
          if (this.sceneVisible) schedule();
        }, { rootMargin: '150px 0px' });
        this.observer.observe(this.scrollScene);
        const measureHeader = () => {
          this.headerHeight = this.header ? Math.ceil(this.header.getBoundingClientRect().height) : 0;
          this.style.setProperty('--kch-header-height', `${this.headerHeight}px`);
          schedule();
        };
        if (this.header && typeof ResizeObserver !== 'undefined') {
          this.headerObserver = new ResizeObserver(measureHeader);
          this.headerObserver.observe(this.header);
        }
        measureHeader();
        this.configureVideo();
      }
      configureVideo() {
        const source = this.mobile.matches ? this.dataset.mobileVideo || this.dataset.desktopVideo : this.dataset.desktopVideo;
        const staticScene = this.reducedMotion.matches || !source;
        this.classList.toggle('kch--static', staticScene);
        this.video.pause();
        if (staticScene) {
          this.classList.remove('kch--video-ready');
          if (this.video.hasAttribute('src')) { this.video.removeAttribute('src'); this.video.load(); }
          this.showCaption(0);
          return;
        }
        if (this.video.getAttribute('src') !== source) {
          this.classList.remove('kch--video-ready');
          this.video.muted = true;
          this.video.src = source;
          this.video.load();
        }
        this.schedule();
      }
      showCaption(index) {
        if (this.captionIndex === index) return;
        this.captionIndex = index;
        this.captions.forEach((caption, position) => {
          caption.classList.toggle('is-current', position === index);
          caption.setAttribute('aria-hidden', position === index ? 'false' : 'true');
        });
      }
      updateScene() {
        if (!this.isConnected || this.reducedMotion.matches || this.classList.contains('kch--static')) return;
        const range = Math.max(1, this.scrollScene.offsetHeight - this.stage.offsetHeight);
        const progress = Math.min(1, Math.max(0, (this.headerHeight - this.scrollScene.getBoundingClientRect().top) / range));
        this.style.setProperty('--kay-progress', progress.toFixed(4));
        this.showCaption(progress < .34 ? 0 : progress < .7 ? 1 : 2);
        if (this.video.readyState < 1 || !Number.isFinite(this.video.duration) || this.video.duration <= 0 || this.video.seeking) return;
        const time = progress * Math.max(0, this.video.duration - .045);
        if (Math.abs(this.video.currentTime - time) > .04) {
          try { this.video.currentTime = time; } catch { return; }
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.headerObserver?.disconnect();
        this.events?.abort();
        this.events = null;
        if (this.video) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
        }
      }
    }
    customElements.define('kay-cinematic-home', KayCinematicHome);
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('kay-cinematic-home').forEach(section => section.initialize());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', register, { once: true });
  else register();
})();

  } catch(e) { console.error(e); }
})();
})();
